/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */

component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});


/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
//   try {
//     new Tobi({
//       // variables from script localization in register-assets.php
//       navLabel: [aucor_starter_strings.prev, aucor_starter_strings.next],
//       closeLabel: aucor_starter_strings.close,
//       loadingIndicatorLabel: aucor_starter_strings.loading,
//       captionsSelector: 'self',
//       captionAttribute: 'data-caption',
//       zoom: false,
//     });
//   } catch (e) {
//     console.log(e);
//   }
}

/**
 * Transparent header on front page and landing page
 * Scroll event with throttling https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event
 */
function transparentHeader(scrollPos) {
  var header = document.querySelector('.site-header');
  if (scrollPos > 50) { // the user has scrolled past half the header, make it sticky
    header.classList.remove('transparent-header');
  } else {
    header.classList.add('transparent-header');
  }
}

// detect IE
var ua = window.navigator.userAgent;
var ie = ua.indexOf('Trident/');
if (ie > 0) {
  console.log('IE detected');
  document.body.classList.add('browser-ie');
}

var last_known_scroll_position = 0;
var ticking = false;

if (document.querySelectorAll('.home').length) {
  window.addEventListener('scroll', function(e) {
    last_known_scroll_position = window.pageYOffset;

    if (!ticking) {
      window.requestAnimationFrame(function() {
        transparentHeader(last_known_scroll_position);
        ticking = false;
      });

      ticking = true;
    }
  });
}

/**
 * Set footer to bottom of page on:
 * - 404
 * - Request a demo
 */
if (document.body.classList.contains('error404') || document.body.classList.contains('page-id-1668')) {
  var html = document.querySelector('html');
  html.setAttribute('style', 'height: 100%;');

  document.body.style.height = '100%';

  var page = document.querySelector('.site');
  page.setAttribute('style', "height: 100%; display: flex; flex-direction: column;");

  var footer = document.querySelector('.site-footer');
  footer.setAttribute('style', 'margin-top: auto;');
}
// also add primary color background to the empty space on the request a demo page
if (document.body.classList.contains('page-id-1668')) {
  var content = document.querySelector('.site-content');
  content.classList.add('fill-content-to-footer');
}

/* anchor offset for sticky header */

(function(document, history, location) {
  var HISTORY_SUPPORT = !!(history && history.pushState);

  var anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,
    OFFSET_HEIGHT_PX: 150,

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init: function() {
      this.scrollToCurrent();
      window.onload = this.scrollToCurrent.bind(this);
      document.body.addEventListener('click', this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset: function() {
      return this.OFFSET_HEIGHT_PX;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor: function(href, pushToHistory) {
      var match, rect, anchorOffset;

      if(!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      match = document.getElementById(href.slice(1));

      if(match) {
        rect = match.getBoundingClientRect();
        anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset();
        window.scrollTo(window.pageXOffset, anchorOffset);

        // Add the state to history as-per normal anchor links
        if(HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent: function() {
      this.scrollIfAnchor(window.location.hash);
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors: function(e) {
      var elem = e.target;

      if(
        elem.nodeName === 'A' &&
        this.scrollIfAnchor(elem.getAttribute('href'), true)
      ) {
        e.preventDefault();
      }
    }
  };

  window.addEventListener(
    'DOMContentLoaded', anchorScrolls.init.bind(anchorScrolls)
  );
})(window.document, window.history, window.location);

document.addEventListener('readystatechange', () => {
  var onpageload = true;
  if (document.readyState == 'complete') checkCookie(onpageload);
});
